import typo from "../../../../constants/dictionaries"
import helper from "../../../../helper/helper";
const columns = ({} = {}) =>
  [
    {
      title: "#",
      dataIndex: "stt",
      width: "45px",
      align: 'center',
      fixed: 'left',
    },
    {
      title: typo.cscore_soHieu,
      dataIndex: "soHieu",
      defaultSortOrder: "descend",
      width: "100px",
      fixed: 'left',
    },
    {
      title: typo.cscore_diaDiem,
      dataIndex: "diaDiem",
      defaultSortOrder: "descend",
      width: "200px",
    },
    {
      title: "Tọa độ",
      children: [
        {
          title: "X",
          dataIndex: "toaDo",
          width: 120,
          render: (value) => helper.getToaDoX(value)
        },
        {
          title: "Y",
          dataIndex: "toaDo",
          width: 120,
          render: (value) => helper.getToaDoY(value)
        }
      ]
    },
    {
      title: typo.cscore_luuLuongNuocThai,
      dataIndex: "luuLuongNuocThai",
      width: "200px",
    },
  ].map(col => ({ ...col}));

export default columns;
